export default __webpack_public_path__ + "media/013d9ce8df2dc83b995c74e0c006c19de806796ca53b8708e8172ff25ef58491.svg";